import { create } from "zustand";
import { JsonTryParse } from "../utils/helpers";
import storage from "../utils/storage";
import { persist } from "zustand/middleware";
import cookieJar from "../utils/cookieJar";
import { isEqual, isNil } from "lodash";
import constants from "../utils/constants";

const useTenantStore = create()(
  persist(
    (set, get) => ({
      systemTenants: [],
      activeSystemTenant: constants.BASIC_SYS_TENANT,
      activeSystemTenantId: null,
      actions: {
        setActiveSystemTenant: (activeSystemTenant) => {
          set(() => ({ activeSystemTenant: activeSystemTenant }));
          // cookieJar.setItem("activeSystemTenantId", activeSystemTenant.id);
        },
        setSystemTenants: (systemTenants) => {
          if (isNil(systemTenants)) return;
          // if (isEqual(get().activeSystemTenant, BASIC_SYS_TENANT)) {
          //   const firstSystemTenant = systemTenants[0];
          //   set(() => ({ activeSystemTenant: firstSystemTenant, systemTenants }));
          //   cookieJar.setItem("activeSystemTenantId", firstSystemTenant.id);
          // } else {
          //   set(() => ({ systemTenants }));
          // }
          let firstSystemTenant = constants.BASIC_SYS_TENANT;
          if (Array.isArray(systemTenants)) {
            firstSystemTenant = systemTenants[0];
          }
          set(() => ({ activeSystemTenant: firstSystemTenant, systemTenants: systemTenants }));
        },
        clearSystemTenants: () => {
          set(() => ({
            systemTenants: [],
            activeSystemTenant: constants.BASIC_SYS_TENANT,
          }));
        },
        hasActiveTenant: () => {
          return get().activeSystemTenant !== constants.BASIC_SYS_TENANT;
        },
      },
    }),
    {
      name: "tenant-store",
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);

export const useActiveTenant = () =>
  useTenantStore((state) => state.activeSystemTenant);

export const useSystemTenantLists = () =>
  useTenantStore((state) => state.systemTenants);

export const useTenantActions = () => useTenantStore((state) => state.actions);

export const useTenantTheme = () => useTenantStore((state) => {
  return {
    primaryHexColor: state.activeSystemTenant?.primaryHexColor,
    secondaryHexColor: state.activeSystemTenant?.secondaryHexColor,
    tertiaryHexColor: state.activeSystemTenant?.tertiaryHexColor,
    logo: state.activeSystemTenant?.logo,
    header: state.activeSystemTenant?.header,
    subHeader: state.activeSystemTenant?.subHeader
  }
});

export default useTenantStore;
